import React from "react";
import OnHoverTooltip from "../../tables/shared/OnHoverTooltip";
import { getIcon } from "../../crm/shared/field_inputs/shared/FormatHelpers";
import { useTranslation } from 'react-i18next';

import { EMAIL_NOTIFICATIONS_FALSE, EMAIL_NOTIFICATIONS_TRUE } from "../../../i18n/keyConstants";


function ExlMailCalendarIcons({
  sendEmailNotifications,
  trueText,
  falseText,
  tooltipPlace
}) {
    const { t } = useTranslation('shared');

  return (
    <div className={'course-icons-modal'}>
      {sendEmailNotifications ? (
        <OnHoverTooltip
          labelClassNames='d-flex margin-none'
          tooltipType='dark'
          tooltipPlace={tooltipPlace ||'left'}
          tooltipEffect='solid'
        >
          <div
            className="course-icons-green"
            style={{ display: 'inline-block' }}
          >
            {getIcon('envelope-check')}
            {getIcon('exlcalendar-check')}
          </div>
          <span
            className='d-flex my-auto'
            style={{ width: 150 }}
          >
            {trueText || t(EMAIL_NOTIFICATIONS_TRUE)}
          </span>
        </OnHoverTooltip>
      ) : (
        <OnHoverTooltip
          labelClassNames='d-flex margin-none'
          tooltipType='dark'
          tooltipPlace={tooltipPlace ||'left'}
          tooltipEffect='solid'
        >
          <span className="course-icons-red">
            {getIcon('envelope-slash')}
            {getIcon('exlcalendar-x')}
          </span>
          <span
            className='d-flex my-auto'
            style={{width: 150}}
          >
           {falseText || t(EMAIL_NOTIFICATIONS_FALSE)} 
          </span>
        </OnHoverTooltip>
      )}
    </div>
  );
}

export default ExlMailCalendarIcons;